module.exports = __webpack_public_path__ + "static/CalibreWeb-Bold-978b9ab93fe7470a658d93205b280cad.woff";